import { enumParser } from '#validation/common/parsers';
import { GuestLinkStatus } from '../constants';
export const guestLinkStatusParser = enumParser(GuestLinkStatus);
